import { connect } from "react-redux";
import { State } from "store";
import { bonus } from "store/bonus";
import { global } from "store/global";
import { profile } from "store/profile";
import { router } from "store/router";
import { title } from "store/title";

const mapStateToProps = (state: State) => ({
  bonus: bonus.selectors.bonus(state),
  carriers: global.selectors.carrierRefs(state),
  currentUser: profile.selectors.User(state),
  operators: global.selectors.operatorRefs(state),
});

const mapDispatchToProps = {
  setHeadBar: title.actions.setHeadBar,
  fetchBonus: bonus.queries.fetchBonus,
  updateBonus: bonus.commands.updateBonus,
  gotoBonusEdit: router.goto.bonus.bonusEdit,
  gotoBonusView: router.goto.bonus.bonusView,
};

export default connect(mapStateToProps, mapDispatchToProps);
